export interface SmithersClientListHistoryState {
  sortColumn: "clientId" | null
  sortDirection: "asc" | "desc"
}

export function getSmithersClientListHistoryState(state: unknown): SmithersClientListHistoryState | undefined {
  if (typeof state !== "object" || state === null || !("smithersClientList" in state)) return undefined
  const snapshot = state.smithersClientList
  if (typeof snapshot !== "object" || snapshot === null || !("sortColumn" in snapshot) || !("sortDirection" in snapshot)) return undefined
  if ((snapshot.sortColumn !== null && snapshot.sortColumn !== "clientId") || (snapshot.sortDirection !== "asc" && snapshot.sortDirection !== "desc")) return undefined
  return { sortColumn: snapshot.sortColumn, sortDirection: snapshot.sortDirection }
}
